import React from 'react';
import { StepIntro } from '../fields';
import { FileUploader } from '../FileUploader';
import { FILE_CATEGORY_LABELS } from '../api';

const HINTS = { projects: 'Your best finished work — these become the gallery.', before_after: 'Pairs of before/after shots work brilliantly.', team: 'You, your team, your workshop.', vehicles: 'Sign-written vans, workwear, banners.', other: 'Anything else you want on the site.' };

export default function StepImages({ order, onFilesChange }) {
  return (
    <div className="space-y-6">
      <StepIntro title="Photos" text="Upload straight from your phone. Good photos make the biggest difference to a website — add plenty." />
      {['projects', 'before_after', 'team', 'vehicles', 'other'].map((c) => <FileUploader key={c} order={order} category={c} label={FILE_CATEGORY_LABELS[c]} hint={HINTS[c]} optional={c !== 'projects'} onChange={onFilesChange} />)}
    </div>
  );
}
